'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002416 from "./presto.-Dashboard-View$$anon$16.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002418 from "./presto.-Dashboard-View$$anon$18.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dSystem$002dStats$0024 from "./presto.types$-Dashboard-System-Stats$.js";
import * as $j_presto$002etypes$0024$002dSite$002dSystem$0024 from "./presto.types$-Site-System$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$15() {
  this.aL2 = null;
  this.aKU = null;
  this.aKV = false;
  this.aL3 = null;
  this.aL4 = false;
  this.aL7 = null;
  this.aL0 = null;
  this.aL1 = false;
  this.aKW = null;
  this.aKX = false;
  this.aKY = null;
  this.aKZ = false;
  this.aL5 = false;
  this.aL6 = false;
  this.aL2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aL7 = "DashboardSystemStats";
}
export { $c_Lpresto_DashboardView$$anon$15 as $c_Lpresto_DashboardView$$anon$15 };
$p = $c_Lpresto_DashboardView$$anon$15.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$15;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$15() {
}
export { $h_Lpresto_DashboardView$$anon$15 as $h_Lpresto_DashboardView$$anon$15 };
$h_Lpresto_DashboardView$$anon$15.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aL2;
});
$p.M = (function() {
  if ((!this.aKV)) {
    this.aKU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aKV = true;
  }
  return this.aKU;
});
$p.O = (function() {
  if ((!this.aL4)) {
    this.aL3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aL4 = true;
  }
  return this.aL3;
});
$p.E = (function() {
  return this.aL7;
});
$p.t = (function() {
  if ((!this.aL1)) {
    this.aL0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("system", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("total", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aL1 = true;
  }
  return this.aL0;
});
$p.N = (function() {
  if ((!this.aKX)) {
    this.aKW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dSite$002dSystem$0024.$m_Lpresto_types$SiteSystem$().ic(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002416.$c_Lpresto_DashboardView$$anon$16())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aKX = true;
  }
  return this.aKW;
});
$p.Q = (function() {
  if ((!this.aKZ)) {
    this.aKY = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002418.$c_Lpresto_DashboardView$$anon$18();
    this.aKZ = true;
  }
  return this.aKY;
});
$p.v = (function() {
  if ((!this.aL6)) {
    this.aL5 = false;
    this.aL6 = true;
  }
  return this.aL5;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee79) => ((p) => \u03b4scrutinee79.cFU(p)))($j_presto$002etypes$0024$002dDashboard$002dSystem$002dStats$0024.$m_Lpresto_types$DashboardSystemStats$())));
});
var $d_Lpresto_DashboardView$$anon$15 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$15, "presto.DashboardView$$anon$15", ({
  Hd: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$15 as $d_Lpresto_DashboardView$$anon$15 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$15.js.map
